// TextImage
export { default as TextImage } from "./TextImage";
export type { default as TextImageProps } from "./TextImageProps.interface";